const dataCert = [
  {
    owner: "Essential Straits - Lot 29",
    area: '4,878 ha',
    pv: '9,024 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lat: 3.728061177665748, lng: 114.3722187325594 },
      { lat: 3.731689093803649, lng: 114.3697042854482 },
      { lat: 3.727903807261293, lng: 114.3650561084253 },
      { lat: 3.725860888209281, lng: 114.3579083633608 },
      { lat: 3.722940919092622, lng: 114.3565692322781 },
      { lat: 3.722906373360034, lng: 114.3626800681981 },
      { lat: 3.719324726073011, lng: 114.3645145005557 },
      { lat: 3.717372073064348, lng: 114.3633671093029 },
      { lat: 3.715769694702737, lng: 114.3585002241432 },
      { lat: 3.714216469637699, lng: 114.3598839841563 },
      { lat: 3.713106793269448, lng: 114.3594469009335 },
      { lat: 3.712742348062251, lng: 114.3611764825362 },
      { lat: 3.713691862381918, lng: 114.3631547255567 },
      { lat: 3.710760111044222, lng: 114.3644395847653 },
      { lat: 3.713880760020007, lng: 114.3662452203102 },
      { lat: 3.711623400374678, lng: 114.3704199000747 },
      { lat: 3.712428338948517, lng: 114.3722072666486 },
      { lat: 3.728061177665748, lng: 114.3722187325594 },
    ],
  },
  {
    owner: "Essential Straits - Lot 30",
    area: '4,878 ha',
    pv: '9,024 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.3641738022602, lat: 3.646189323749283 },
      { lng: 114.3661283735778, lat: 3.645746498054637 },
      { lng: 114.3679472580241, lat: 3.646135325167809 },
      { lng: 114.3683763271501, lat: 3.647573790265442 },
      { lng: 114.3719911238338, lat: 3.665268547529865 },
      { lng: 114.3724625586531, lat: 3.693620130448755 },
      { lng: 114.3681572454363, lat: 3.692870181362007 },
      { lng: 114.3680115757401, lat: 3.692223957419413 },
      { lng: 114.3708782446071, lat: 3.688538793461084 },
      { lng: 114.3703059247036, lat: 3.684829548437961 },
      { lng: 114.3677946708088, lat: 3.684251197433074 },
      { lng: 114.3641941371419, lat: 3.684755272241118 },
      { lng: 114.3619615055988, lat: 3.688181405742863 },
      { lng: 114.3593565490457, lat: 3.685793759612986 },
      { lng: 114.3564370842222, lat: 3.684370022460799 },
      { lng: 114.3519979137737, lat: 3.680295098381934 },
      { lng: 114.3617872435624, lat: 3.663981534587152 },
      { lng: 114.3622326034103, lat: 3.66015051829943 },
      { lng: 114.3615837056973, lat: 3.658870413642859 },
      { lng: 114.361763120294, lat: 3.656588688314582 },
      { lng: 114.3600637430701, lat: 3.654336077994508 },
      { lng: 114.357461655647, lat: 3.653753327139929 },
      { lng: 114.3527001768801, lat: 3.657859591676536 },
      { lng: 114.351159973989, lat: 3.6574533813275 },
      { lng: 114.3496661425448, lat: 3.653685309845902 },
      { lng: 114.3641738022602, lat: 3.646189323749283 },
    ],
  },
  {
    owner: "Essential Straits - Lot 31",
    area: '4,878 ha',
    pv: '9,024 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.3093496414568, lat: 3.634849822159934 },
      { lng: 114.3103606039618, lat: 3.63214746611138 },
      { lng: 114.3080896357725, lat: 3.628589501504216 },
      { lng: 114.3091519491588, lat: 3.625900314104689 },
      { lng: 114.3145070512044, lat: 3.626432216345072 },
      { lng: 114.3176388853074, lat: 3.623574319298892 },
      { lng: 114.3178892036872, lat: 3.621046261521366 },
      { lng: 114.3167314880967, lat: 3.619293071126483 },
      { lng: 114.3145430129231, lat: 3.618399570045264 },
      { lng: 114.3146319457868, lat: 3.61628091106079 },
      { lng: 114.3165075265989, lat: 3.616038753605554 },
      { lng: 114.318502062907, lat: 3.614102814268985 },
      { lng: 114.3188421549855, lat: 3.612026020893905 },
      { lng: 114.3174604551446, lat: 3.610337231475429 },
      { lng: 114.3203733789628, lat: 3.60610006159482 },
      { lng: 114.3173905149853, lat: 3.604473472316083 },
      { lng: 114.3196350424017, lat: 3.600814015104939 },
      { lng: 114.3234624980335, lat: 3.597392779720012 },
      { lng: 114.3403436541967, lat: 3.595431394184657 },
      { lng: 114.3414758219756, lat: 3.592961498002182 },
      { lng: 114.35080748521, lat: 3.592327096656188 },
      { lng: 114.3527482212169, lat: 3.597956021075923 },
      { lng: 114.3555525914711, lat: 3.604691768477144 },
      { lng: 114.3570536010162, lat: 3.608927052639437 },
      { lng: 114.3576674635231, lat: 3.612297362862054 },
      { lng: 114.3569723188792, lat: 3.61898037351648 },
      { lng: 114.3565647933343, lat: 3.624656681979772 },
      { lng: 114.3545727175963, lat: 3.627530560423963 },
      { lng: 114.3498619112135, lat: 3.630377854706299 },
      { lng: 114.3451408860692, lat: 3.634226837915445 },
      { lng: 114.3419120097575, lat: 3.637679450772074 },
      { lng: 114.3407598698679, lat: 3.640013186538416 },
      { lng: 114.3398833873768, lat: 3.643162936103862 },
      { lng: 114.3397429460113, lat: 3.645363425128205 },
      { lng: 114.3376295721571, lat: 3.646289499923474 },
      { lng: 114.3358163282946, lat: 3.647894706379417 },
      { lng: 114.3331985695384, lat: 3.654623236722703 },
      { lng: 114.3319539294491, lat: 3.655883015154811 },
      { lng: 114.3205350280203, lat: 3.651412444312826 },
      { lng: 114.318571245048, lat: 3.648424360898962 },
      { lng: 114.3161556977352, lat: 3.647941276407844 },
      { lng: 114.3120118704248, lat: 3.649763425670609 },
      { lng: 114.3089698137281, lat: 3.648328551381388 },
      { lng: 114.307365386117, lat: 3.635484353032461 },
      { lng: 114.3093496414568, lat: 3.634849822159934 },
    ],
  },
  {
    owner: "Essential Straits - Lot 258",
    area: '4,878 ha',
    pv: '9,024 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.3398889934218, lat: 3.643165998965771 },
      { lng: 114.3411350437137, lat: 3.639353619955167 },
      { lng: 114.3421002884528, lat: 3.637685058775909 },
      { lng: 114.3436523197759, lat: 3.63603724562225 },
      { lng: 114.3458169451711, lat: 3.633676954119402 },
      { lng: 114.3490681021073, lat: 3.631078488435248 },
      { lng: 114.352221991607, lat: 3.629203056193204 },
      { lng: 114.35486441606, lat: 3.627584136341587 },
      { lng: 114.3566149529067, lat: 3.624760516733571 },
      { lng: 114.3576114744453, lat: 3.612687322994208 },
      { lng: 114.3571621088596, lat: 3.60940574291214 },
      { lng: 114.3561171671411, lat: 3.606076082756321 },
      { lng: 114.354723373758, lat: 3.602766644300874 },
      { lng: 114.3534231292914, lat: 3.59941423174726 },
      { lng: 114.3513994023694, lat: 3.594033357055434 },
      { lng: 114.3508963317227, lat: 3.592296323800799 },
      { lng: 114.3582713989051, lat: 3.591559225778887 },
      { lng: 114.3649947646211, lat: 3.622690095902604 },
      { lng: 114.3620837683901, lat: 3.627428647788114 },
      { lng: 114.3663156493117, lat: 3.636706369694341 },
      { lng: 114.3626584377385, lat: 3.639722195021469 },
      { lng: 114.3724771443356, lat: 3.644080055399658 },
      { lng: 114.3737813518389, lat: 3.646257797577059 },
      { lng: 114.3717205825659, lat: 3.646011608300376 },
      { lng: 114.3696645402058, lat: 3.648012802495139 },
      { lng: 114.3721161041231, lat: 3.651593105408785 },
      { lng: 114.37359162359, lat: 3.65050043962363 },
      { lng: 114.3838265772952, lat: 3.700281348627349 },
      { lng: 114.3768288385038, lat: 3.721157649723486 },
      { lng: 114.3721970003983, lat: 3.728143485718327 },
      { lng: 114.3722729243572, lat: 3.712382852751053 },
      { lng: 114.3736128287528, lat: 3.713129968044148 },
      { lng: 114.3753844233725, lat: 3.712915043550634 },
      { lng: 114.3755982308306, lat: 3.711024776612688 },
      { lng: 114.3748682687586, lat: 3.707779075957256 },
      { lng: 114.3734431646481, lat: 3.706207893718952 },
      { lng: 114.3732725136116, lat: 3.702788453327734 },
      { lng: 114.3767608799826, lat: 3.699943707549894 },
      { lng: 114.3772161796888, lat: 3.697616058548788 },
      { lng: 114.3770355235826, lat: 3.693816188511391 },
      { lng: 114.3755663205403, lat: 3.692945964983401 },
      { lng: 114.375292277019, lat: 3.693103055034499 },
      { lng: 114.3724414386738, lat: 3.693594116019788 },
      { lng: 114.372294970946, lat: 3.689343653958831 },
      { lng: 114.3722411562203, lat: 3.683250046411538 },
      { lng: 114.3720922370404, lat: 3.673367254426446 },
      { lng: 114.3720060281714, lat: 3.665238308337611 },
      { lng: 114.3683592745468, lat: 3.647399873485331 },
      { lng: 114.367909618825, lat: 3.646121358613322 },
      { lng: 114.3660793248502, lat: 3.645715490363483 },
      { lng: 114.3642088832452, lat: 3.646230939177745 },
      { lng: 114.3495970214498, lat: 3.653758779425076 },
      { lng: 114.347318723499, lat: 3.647137332581103 },
      { lng: 114.342686731528, lat: 3.644019838182845 },
      { lng: 114.3398755953397, lat: 3.645276506642537 },
      { lng: 114.3398889934218, lat: 3.643165998965771 },
    ],
  },
  {
    owner: "Grand Olie Sdn Bhd",
    area: '13,362 ha',
    pv: '24,753 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.1450973699495, lat: 4.060095708774473 },
      { lng: 114.1452262341289, lat: 4.061042835346991 },
      { lng: 114.1459551706471, lat: 4.06191649906443 },
      { lng: 114.1469970317303, lat: 4.065844923429134 },
      { lng: 114.1472706582403, lat: 4.066479757127251 },
      { lng: 114.147846155854, lat: 4.06871033452867 },
      { lng: 114.1483611041922, lat: 4.070754569254341 },
      { lng: 114.1491999909883, lat: 4.072401317704591 },
      { lng: 114.1497776622215, lat: 4.073633034916234 },
      { lng: 114.1504759404102, lat: 4.074137530013906 },
      { lng: 114.1515388945261, lat: 4.074034292695065 },
      { lng: 114.1525332292781, lat: 4.073426482865419 },
      { lng: 114.1536546968335, lat: 4.074076514808507 },
      { lng: 114.1540587523332, lat: 4.074623493275906 },
      { lng: 114.1543811931514, lat: 4.075566153621654 },
      { lng: 114.1541315228643, lat: 4.07669752477117 },
      { lng: 114.1032422676166, lat: 4.076641235590489 },
      { lng: 114.1028441863958, lat: 4.071342566332274 },
      { lng: 114.102566916614, lat: 4.065547314948979 },
      { lng: 114.1028528138228, lat: 4.064103511154921 },
      { lng: 114.1045922392497, lat: 4.063569644476823 },
      { lng: 114.1045268024367, lat: 4.060552084054558 },
      { lng: 114.106022979059, lat: 4.057412236025591 },
      { lng: 114.1071866662325, lat: 4.045431976345557 },
      { lng: 114.1086916433147, lat: 4.036517239532756 },
      { lng: 114.1084859081644, lat: 4.032525046528792 },
      { lng: 114.1086287643051, lat: 4.030847932036018 },
      { lng: 114.1107316686886, lat: 4.029197740015887 },
      { lng: 114.1110764709044, lat: 4.023592714757005 },
      { lng: 114.1106069488764, lat: 4.022575693987844 },
      { lng: 114.1111139821802, lat: 4.022157470256947 },
      { lng: 114.1090519718961, lat: 4.020231130394985 },
      { lng: 114.1093683694374, lat: 4.018957525669816 },
      { lng: 114.1098115335973, lat: 4.009616267152979 },
      { lng: 114.1104757651206, lat: 4.001516251949506 },
      { lng: 114.1236493873156, lat: 4.001354255751481 },
      { lng: 114.1488978785801, lat: 3.999136599085181 },
      { lng: 114.1504104074879, lat: 3.983696255798159 },
      { lng: 114.1557175310159, lat: 3.980158505837605 },
      { lng: 114.1586879390684, lat: 3.976213683195681 },
      { lng: 114.1572865451173, lat: 3.971015284933788 },
      { lng: 114.1549837868765, lat: 3.968231593936368 },
      { lng: 114.1581865485563, lat: 3.967274240254943 },
      { lng: 114.1616148321558, lat: 3.96283011275484 },
      { lng: 114.1636893134037, lat: 3.960394244749019 },
      { lng: 114.1663577530189, lat: 3.95548081436448 },
      { lng: 114.1688888975841, lat: 3.95170574386202 },
      { lng: 114.1723837097586, lat: 3.948379440959224 },
      { lng: 114.1736528209252, lat: 3.947690201068109 },
      { lng: 114.1765614357193, lat: 3.946911639522794 },
      { lng: 114.1785925375986, lat: 3.946338968239538 },
      { lng: 114.1798619847469, lat: 3.945576343723344 },
      { lng: 114.1807914071349, lat: 3.944215425895103 },
      { lng: 114.1815725163108, lat: 3.943610595595266 },
      { lng: 114.1821947308818, lat: 3.941962561947563 },
      { lng: 114.1835760435531, lat: 3.940708274302049 },
      { lng: 114.1842108738385, lat: 3.939258668458046 },
      { lng: 114.1844083429499, lat: 3.938395369932152 },
      { lng: 114.1850836239583, lat: 3.937415734010703 },
      { lng: 114.1857821978539, lat: 3.936520956571477 },
      { lng: 114.1867919128123, lat: 3.935420286675942 },
      { lng: 114.1870810247763, lat: 3.934190132883703 },
      { lng: 114.1882995231781, lat: 3.934278284178929 },
      { lng: 114.1886831459778, lat: 3.933740020892754 },
      { lng: 114.1896004914352, lat: 3.931171590161462 },
      { lng: 114.190506821554, lat: 3.929975354670394 },
      { lng: 114.1909520119116, lat: 3.92580809093361 },
      { lng: 114.1916159827565, lat: 3.92456646335653 },
      { lng: 114.191952455201, lat: 3.922177591074199 },
      { lng: 114.192588984752, lat: 3.920940109482369 },
      { lng: 114.1930771579022, lat: 3.920145487009071 },
      { lng: 114.1933601587221, lat: 3.918788110399491 },
      { lng: 114.1911063950836, lat: 3.916304274991575 },
      { lng: 114.1887055572399, lat: 3.913193316003402 },
      { lng: 114.1878282090594, lat: 3.910899205300431 },
      { lng: 114.1868469081526, lat: 3.909662760291222 },
      { lng: 114.1860992243849, lat: 3.906749981192025 },
      { lng: 114.1841697149619, lat: 3.905019941219371 },
      { lng: 114.1833946039817, lat: 3.903679969395859 },
      { lng: 114.183444750147, lat: 3.902156199065755 },
      { lng: 114.1824195645607, lat: 3.900262311601277 },
      { lng: 114.182348048424, lat: 3.899192920294266 },
      { lng: 114.1820888705163, lat: 3.898315001335901 },
      { lng: 114.1828911785474, lat: 3.896505625458331 },
      { lng: 114.1831918618907, lat: 3.895140471240478 },
      { lng: 114.1840539643935, lat: 3.893843314962973 },
      { lng: 114.1847575481035, lat: 3.890108441680529 },
      { lng: 114.1873414185591, lat: 3.888588239963585 },
      { lng: 114.1899440083026, lat: 3.889384965847416 },
      { lng: 114.1920165084009, lat: 3.88786972513785 },
      { lng: 114.1940602688416, lat: 3.884207916887322 },
      { lng: 114.200851235728, lat: 3.879039026482373 },
      { lng: 114.2049973764358, lat: 3.875802808879414 },
      { lng: 114.2056815190452, lat: 3.873284164107922 },
      { lng: 114.2112893666541, lat: 3.867812703839773 },
      { lng: 114.2127004132494, lat: 3.865931748795931 },
      { lng: 114.2155604066854, lat: 3.860301220531436 },
      { lng: 114.2337115779326, lat: 3.850273635462697 },
      { lng: 114.2351182243164, lat: 3.850273967684543 },
      { lng: 114.2352988670672, lat: 3.854858215596279 },
      { lng: 114.236581521288, lat: 3.863954330250349 },
      { lng: 114.237357764476, lat: 3.869237088879754 },
      { lng: 114.238968945544, lat: 3.879649630160985 },
      { lng: 114.2527146943595, lat: 3.897061720492621 },
      { lng: 114.2479711021311, lat: 3.898926744204351 },
      { lng: 114.2439174163944, lat: 3.903029547607085 },
      { lng: 114.2429062348453, lat: 3.907798400477649 },
      { lng: 114.24254993539, lat: 3.912502089066595 },
      { lng: 114.2403303546253, lat: 3.914818385312712 },
      { lng: 114.2391542839658, lat: 3.917453880090923 },
      { lng: 114.2393619026234, lat: 3.920692405107261 },
      { lng: 114.2393292087563, lat: 3.923230710730994 },
      { lng: 114.2384428059507, lat: 3.924557279870424 },
      { lng: 114.2363188736442, lat: 3.925949016698074 },
      { lng: 114.2339895221673, lat: 3.927370267233477 },
      { lng: 114.2329896925296, lat: 3.92780620067806 },
      { lng: 114.2314013144789, lat: 3.930129231126658 },
      { lng: 114.230966092163, lat: 3.933114551664732 },
      { lng: 114.2320320331885, lat: 3.942720092115016 },
      { lng: 114.2324188592024, lat: 3.94321583721946 },
      { lng: 114.2323337522282, lat: 3.945151271179222 },
      { lng: 114.2328195426257, lat: 3.946219812993728 },
      { lng: 114.2378255734552, lat: 3.949734100462087 },
      { lng: 114.2393540133441, lat: 3.95055537860585 },
      { lng: 114.2396691362672, lat: 3.951498282918466 },
      { lng: 114.2394837245475, lat: 3.952618800895506 },
      { lng: 114.2381228252493, lat: 3.953669218370988 },
      { lng: 114.2377002030372, lat: 3.953561498345097 },
      { lng: 114.2342723486535, lat: 3.953301223004391 },
      { lng: 114.2323105583735, lat: 3.954270402347319 },
      { lng: 114.2304671054813, lat: 3.954577445203773 },
      { lng: 114.2290491924703, lat: 3.956897499396374 },
      { lng: 114.2293305541492, lat: 3.958314822243946 },
      { lng: 114.2321072971397, lat: 3.962193291329976 },
      { lng: 114.2320188642307, lat: 3.963594639730264 },
      { lng: 114.231351623352, lat: 3.964742612589582 },
      { lng: 114.2299183080404, lat: 3.965904882820162 },
      { lng: 114.2281413682588, lat: 3.967304702727204 },
      { lng: 114.2269537586973, lat: 3.967338722883477 },
      { lng: 114.2256026722492, lat: 3.966419433511897 },
      { lng: 114.2238002391101, lat: 3.966497754003764 },
      { lng: 114.2218110293142, lat: 3.965899165043122 },
      { lng: 114.2199698977993, lat: 3.966511343253902 },
      { lng: 114.2193908619544, lat: 3.967295049153589 },
      { lng: 114.2195632076351, lat: 3.968399816441932 },
      { lng: 114.2200527175485, lat: 3.969242905145371 },
      { lng: 114.2206875560015, lat: 3.970872895439467 },
      { lng: 114.2211965908138, lat: 3.971619237113779 },
      { lng: 114.2222474296937, lat: 3.972932420363821 },
      { lng: 114.2237194853376, lat: 3.974462778539791 },
      { lng: 114.2245520811447, lat: 3.975574694747673 },
      { lng: 114.2250906634621, lat: 3.976306127030972 },
      { lng: 114.2247645730575, lat: 3.977587731723801 },
      { lng: 114.223753776025, lat: 3.977806488235122 },
      { lng: 114.2226750735795, lat: 3.977709777338001 },
      { lng: 114.2209685493986, lat: 3.978512620926785 },
      { lng: 114.2180632990148, lat: 3.978365542028825 },
      { lng: 114.2162259920706, lat: 3.977727896073378 },
      { lng: 114.2147919001449, lat: 3.97741849682434 },
      { lng: 114.2132008894739, lat: 3.977470460034156 },
      { lng: 114.2115656521652, lat: 3.977490682801131 },
      { lng: 114.2104039755492, lat: 3.977794666094952 },
      { lng: 114.2096370466339, lat: 3.978012819626333 },
      { lng: 114.2087854345575, lat: 3.978833876704642 },
      { lng: 114.2075143323232, lat: 3.97887872688192 },
      { lng: 114.2068826385873, lat: 3.976226763062127 },
      { lng: 114.2058481698038, lat: 3.975563258309527 },
      { lng: 114.2053425537577, lat: 3.975117569235247 },
      { lng: 114.2046364368249, lat: 3.975314487898932 },
      { lng: 114.2037813771089, lat: 3.97544841910976 },
      { lng: 114.2020011791203, lat: 3.976517004593104 },
      { lng: 114.201274725168, lat: 3.977184833223745 },
      { lng: 114.200917897103, lat: 3.977747880793793 },
      { lng: 114.1998303025338, lat: 3.978254093063976 },
      { lng: 114.198639512511, lat: 3.979702769576511 },
      { lng: 114.1975481291298, lat: 3.981506174114531 },
      { lng: 114.1968312285542, lat: 3.982429804457139 },
      { lng: 114.1966661016881, lat: 3.982936397118341 },
      { lng: 114.1960734721959, lat: 3.984181779833207 },
      { lng: 114.1955615184243, lat: 3.985804425480423 },
      { lng: 114.1956974127084, lat: 3.986941125371725 },
      { lng: 114.1955606080159, lat: 3.987983655659648 },
      { lng: 114.1960582475975, lat: 3.989225466111808 },
      { lng: 114.1960322679747, lat: 3.990604913030559 },
      { lng: 114.1961163762353, lat: 3.991017373647592 },
      { lng: 114.1957351658159, lat: 3.991576318726405 },
      { lng: 114.1947261117502, lat: 3.991830153791645 },
      { lng: 114.1935102913377, lat: 3.991516173117564 },
      { lng: 114.192722231833, lat: 3.990355439438299 },
      { lng: 114.1920793784485, lat: 3.989888747318163 },
      { lng: 114.1919750279402, lat: 3.988641821853826 },
      { lng: 114.1923721519761, lat: 3.987466961475387 },
      { lng: 114.1924003163966, lat: 3.986256937449118 },
      { lng: 114.1927698890725, lat: 3.985600908967857 },
      { lng: 114.1925874262268, lat: 3.984833529224249 },
      { lng: 114.1917111463802, lat: 3.98406320882162 },
      { lng: 114.1905234012138, lat: 3.983660632089901 },
      { lng: 114.189634913128, lat: 3.98324594694858 },
      { lng: 114.1889109032894, lat: 3.983344988188898 },
      { lng: 114.1873705884984, lat: 3.984557761618917 },
      { lng: 114.1872023376693, lat: 3.985594246387159 },
      { lng: 114.1869394429909, lat: 3.986468240110298 },
      { lng: 114.1864275078916, lat: 3.987279549494168 },
      { lng: 114.1848397033308, lat: 3.990998759840584 },
      { lng: 114.1848300624835, lat: 3.992293107278292 },
      { lng: 114.1843073998292, lat: 3.993385694016577 },
      { lng: 114.183918630393, lat: 3.99620778916076 },
      { lng: 114.183564982175, lat: 3.997622401189805 },
      { lng: 114.1834292649657, lat: 4.000574602011243 },
      { lng: 114.1830145261747, lat: 4.001588298929575 },
      { lng: 114.1830159587749, lat: 4.002577380416085 },
      { lng: 114.1826367606827, lat: 4.003205292427984 },
      { lng: 114.1819055606238, lat: 4.003365322859303 },
      { lng: 114.1807123516417, lat: 4.002902235864383 },
      { lng: 114.1794157642937, lat: 4.001684943754798 },
      { lng: 114.1792237431573, lat: 4.000190646678069 },
      { lng: 114.1799127003041, lat: 3.99781423844633 },
      { lng: 114.1796630720845, lat: 3.996507995393197 },
      { lng: 114.1798453917128, lat: 3.994751237846873 },
      { lng: 114.1805030996663, lat: 3.992960816905904 },
      { lng: 114.1804869704659, lat: 3.99196638061467 },
      { lng: 114.179510839846, lat: 3.991102242862343 },
      { lng: 114.1782421556883, lat: 3.990926125704419 },
      { lng: 114.1769782088247, lat: 3.991619082868851 },
      { lng: 114.1758298427907, lat: 3.992464992068082 },
      { lng: 114.1755694490135, lat: 3.993056635110378 },
      { lng: 114.1756426886443, lat: 3.99519942574771 },
      { lng: 114.1753817428858, lat: 3.996080504451548 },
      { lng: 114.175388931024, lat: 3.997116360288907 },
      { lng: 114.1751528759433, lat: 3.997659489667007 },
      { lng: 114.1753154205073, lat: 4.000442521004213 },
      { lng: 114.1753333228573, lat: 4.00160449848782 },
      { lng: 114.1752850418988, lat: 4.002383157770209 },
      { lng: 114.1754463003972, lat: 4.002958886076871 },
      { lng: 114.175358819125, lat: 4.003891225286114 },
      { lng: 114.1748523606257, lat: 4.004662982340352 },
      { lng: 114.1743054364763, lat: 4.004764569330406 },
      { lng: 114.1733692791387, lat: 4.005620447514282 },
      { lng: 114.1726711228459, lat: 4.005886239115687 },
      { lng: 114.1715090751726, lat: 4.006152821794852 },
      { lng: 114.1708123032692, lat: 4.006982588126412 },
      { lng: 114.1708045321384, lat: 4.008499024997696 },
      { lng: 114.1713207257392, lat: 4.010899635594503 },
      { lng: 114.1719690488171, lat: 4.01266270052355 },
      { lng: 114.1705595876026, lat: 4.014321153848541 },
      { lng: 114.1699346193198, lat: 4.015667181831459 },
      { lng: 114.166558893469, lat: 4.019866232490083 },
      { lng: 114.1635735105678, lat: 4.022608220595778 },
      { lng: 114.1630246188664, lat: 4.023861324754434 },
      { lng: 114.1619550456725, lat: 4.025964864730895 },
      { lng: 114.1613818398808, lat: 4.028536026124511 },
      { lng: 114.1614337143692, lat: 4.029912475242841 },
      { lng: 114.1614948935386, lat: 4.030679572785494 },
      { lng: 114.1621065290597, lat: 4.031543692778367 },
      { lng: 114.1622724362143, lat: 4.032689389139239 },
      { lng: 114.162600677896, lat: 4.033835242546029 },
      { lng: 114.1622967645397, lat: 4.034670063353016 },
      { lng: 114.1594855048028, lat: 4.035054650143239 },
      { lng: 114.1583622295986, lat: 4.034023584963085 },
      { lng: 114.1562452829179, lat: 4.032713809586996 },
      { lng: 114.1546073567679, lat: 4.032704962903417 },
      { lng: 114.1537383672156, lat: 4.033155309022151 },
      { lng: 114.1526090353599, lat: 4.033621235360881 },
      { lng: 114.1516325583412, lat: 4.034632923660578 },
      { lng: 114.1502323687111, lat: 4.039284843661124 },
      { lng: 114.1496303921575, lat: 4.042299455018153 },
      { lng: 114.1488784297558, lat: 4.04322284494593 },
      { lng: 114.1488229294369, lat: 4.044224564540413 },
      { lng: 114.1484647337713, lat: 4.045620659352376 },
      { lng: 114.1484258491996, lat: 4.046936631714454 },
      { lng: 114.1489748092962, lat: 4.04806069791237 },
      { lng: 114.1505512220383, lat: 4.048700197505394 },
      { lng: 114.1512089144967, lat: 4.048922671632673 },
      { lng: 114.1522400427579, lat: 4.048660328135228 },
      { lng: 114.1532052856512, lat: 4.048585994637204 },
      { lng: 114.1540682093337, lat: 4.049044059270069 },
      { lng: 114.1549906754431, lat: 4.049243439155585 },
      { lng: 114.1562849223853, lat: 4.049256831438445 },
      { lng: 114.1569700739754, lat: 4.0500099498563 },
      { lng: 114.1567859299504, lat: 4.051319555233485 },
      { lng: 114.1548012522015, lat: 4.053734178955166 },
      { lng: 114.152825982194, lat: 4.054735580577452 },
      { lng: 114.1490843162993, lat: 4.054696907492285 },
      { lng: 114.1482121632789, lat: 4.055031705821322 },
      { lng: 114.1468545917203, lat: 4.05499647367191 },
      { lng: 114.1463795709935, lat: 4.055338622165886 },
      { lng: 114.1454374425604, lat: 4.055964943167106 },
      { lng: 114.1447710041698, lat: 4.056994028033273 },
      { lng: 114.1445471571063, lat: 4.057887972786083 },
      { lng: 114.144599532392, lat: 4.058832180649065 },
      { lng: 114.1450973699495, lat: 4.060095708774473 },       
    ],
  },
  {
    owner: "Grand Olie Sdn Bhd (excluded)",
    area: 'N/A',
    pv: 'N/A',
    cert_no: "tbo",
    isVerified: false,
    isValid: false,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.1147180658581, lat: 4.039962150323126 },
      { lng: 114.1162024226715, lat: 4.040298056162747 },
      { lng: 114.1169631209656, lat: 4.041343040545188 },
      { lng: 114.11786414943, lat: 4.04183889471527 },
      { lng: 114.1182007032642, lat: 4.04277451902098 },
      { lng: 114.119333778374, lat: 4.043272761978471 },
      { lng: 114.1198995979445, lat: 4.045087168520428 },
      { lng: 114.1193854039067, lat: 4.046003763027391 },
      { lng: 114.1179331292962, lat: 4.046692589531093 },
      { lng: 114.1174544803975, lat: 4.046365447216958 },
      { lng: 114.1174572755456, lat: 4.04616951340408 },
      { lng: 114.1170155881876, lat: 4.045681792536972 },
      { lng: 114.1151908330486, lat: 4.045491160847719 },
      { lng: 114.1143984945326, lat: 4.048322460252358 },
      { lng: 114.1130259543144, lat: 4.048425292054295 },
      { lng: 114.1124316284259, lat: 4.047889042796071 },
      { lng: 114.1126220161321, lat: 4.047224943531112 },
      { lng: 114.1131403711241, lat: 4.047224039331429 },
      { lng: 114.11255381876, lat: 4.045782053377137 },
      { lng: 114.1118031574297, lat: 4.045328986889788 },
      { lng: 114.1147180658581, lat: 4.039962150323126 },      
    ],
  },  
  {
    owner: "Green Tree Plantation (Lot 4)",
    area: '1,760 ha',
    pv: '3,220 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.1337944857134, lat: 4.192947268812822 },
      { lng: 114.1927342487271, lat: 4.175059865576693 },
      { lng: 114.1923736042249, lat: 4.177453843487833 },
      { lng: 114.1924440668453, lat: 4.180238084053869 },
      { lng: 114.1928027279894, lat: 4.18284732337959 },
      { lng: 114.1937980818523, lat: 4.185318431417289 },
      { lng: 114.1944465483729, lat: 4.18724002763387 },
      { lng: 114.1939654276596, lat: 4.189140777424219 },
      { lng: 114.1926584053723, lat: 4.190547815095964 },
      { lng: 114.1935937614531, lat: 4.193688633736784 },
      { lng: 114.1955532264407, lat: 4.196276189279168 },
      { lng: 114.1980250143236, lat: 4.19923498873442 },
      { lng: 114.2008087821038, lat: 4.201847501055974 },
      { lng: 114.2008994732854, lat: 4.205290658935811 },
      { lng: 114.2003058740514, lat: 4.208367271134085 },
      { lng: 114.2002237716819, lat: 4.21114000229527 },
      { lng: 114.201099193392, lat: 4.213714844866883 },
      { lng: 114.2017564945569, lat: 4.215207177784848 },
      { lng: 114.2020577056982, lat: 4.216514350252059 },
      { lng: 114.197241559241, lat: 4.215318980436786 },
      { lng: 114.1937469363425, lat: 4.215137416853251 },
      { lng: 114.1874922007257, lat: 4.213290612041673 },
      { lng: 114.1842936587225, lat: 4.213288367317687 },
      { lng: 114.165303438074, lat: 4.206481841414548 },
      { lng: 114.1606521882668, lat: 4.203694229814164 },
      { lng: 114.1536995687757, lat: 4.201692139657353 },
      { lng: 114.1480494850445, lat: 4.201358943783204 },
      { lng: 114.1435478958826, lat: 4.200348008114125 },
      { lng: 114.1374984956713, lat: 4.197125257902918 },
      { lng: 114.1337944857134, lat: 4.192947268812822 },  
    ],
  },
  {
    owner: "Green Tree Plantation (Lot 5)",
    area: '7,530 ha',
    pv: '13,945 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.1060727198639, lat: 4.163777381885949 },
      { lng: 114.1001784763157, lat: 4.15463364304551 },
      { lng: 114.0957654309073, lat: 4.15227266193654 },
      { lng: 114.0954429011424, lat: 4.147874923411186 },
      { lng: 114.0972804102031, lat: 4.142478057721514 },
      { lng: 114.0975534003801, lat: 4.138886595095491 },
      { lng: 114.1046819352573, lat: 4.125221546754266 },
      { lng: 114.1070630410079, lat: 4.118471597838153 },
      { lng: 114.1083250070372, lat: 4.108977803935679 },
      { lng: 114.1073925070714, lat: 4.100123416522488 },
      { lng: 114.1073013467555, lat: 4.090595777575971 },
      { lng: 114.1044191520823, lat: 4.08252219762058 },
      { lng: 114.104657904675, lat: 4.076775414953802 },    //_ bottom left
      { lng: 114.1461152447005, lat: 4.076908093995915 },   //_ bottom right
      { lng: 114.1425039534118, lat: 4.080234837268259 },
      { lng: 114.1446291377691, lat: 4.08435062428695 },
      { lng: 114.1475238190019, lat: 4.087711811069901 },
      { lng: 114.152258895004, lat: 4.091535171870737 },
      { lng: 114.1550116321332, lat: 4.09337087580633 },
      { lng: 114.1510335389946, lat: 4.096746347964398 },
      { lng: 114.1494994053895, lat: 4.100893995860437 },
      { lng: 114.1491908186706, lat: 4.103355569810957 },
      { lng: 114.1455835699221, lat: 4.103142719693171 },
      { lng: 114.1411767413012, lat: 4.106462927752369 },
      { lng: 114.1426832591313, lat: 4.111298804988283 },
      { lng: 114.1451070637684, lat: 4.115842583743901 },
      { lng: 114.1467760369003, lat: 4.119180514229481 },
      { lng: 114.1484462472494, lat: 4.123740214865894 },
      { lng: 114.1495115728529, lat: 4.125415164477277 },
      { lng: 114.1534763668745, lat: 4.126484559002942 },
      { lng: 114.155764953265, lat: 4.126637520219496 },
      { lng: 114.1553084260037, lat: 4.128772104191378 },
      { lng: 114.1542406325945, lat: 4.131213521389859 },
      { lng: 114.1551586380204, lat: 4.1345753073 },
      { lng: 114.1576055431186, lat: 4.136105321591825 },
      { lng: 114.1602040548805, lat: 4.136104357517279 },
      { lng: 114.1631064074793, lat: 4.135491163243075 },
      { lng: 114.1667705621135, lat: 4.134267780225351 },
      { lng: 114.1678323797122, lat: 4.130757750789091 },
      { lng: 114.1670583083253, lat: 4.127249078828393 },
      { lng: 114.1675110031617, lat: 4.125572933017155 },
      { lng: 114.1690366290578, lat: 4.1255731074329 },
      { lng: 114.1695022883993, lat: 4.12785920348272 },
      { lng: 114.1710401611456, lat: 4.130910771994354 },
      { lng: 114.1733493374095, lat: 4.135037108403686 },
      { lng: 114.1748897271093, lat: 4.137790834752646 },
      { lng: 114.1733681992892, lat: 4.140391311539326 },
      { lng: 114.1724626437289, lat: 4.1431527740418 },
      { lng: 114.1739916394152, lat: 4.144618719116524 },
      { lng: 114.1759775228633, lat: 4.146284400200504 },
      { lng: 114.1776598092296, lat: 4.147799862149606 },
      { lng: 114.1772135707157, lat: 4.149619755020676 },
      { lng: 114.1760111096549, lat: 4.152504274340258 },
      { lng: 114.1755662627812, lat: 4.15478428216975 },
      { lng: 114.1775612782464, lat: 4.15706719792459 },
      { lng: 114.1816953138149, lat: 4.159353220032227 },
      { lng: 114.1830766245114, lat: 4.160420833730831 },
      { lng: 114.1832432106324, lat: 4.162252101679473 },
      { lng: 114.1815898498124, lat: 4.165919242285079 },
      { lng: 114.1808432227862, lat: 4.168368028876567 },
      { lng: 114.1810149529155, lat: 4.170820912747735 },
      { lng: 114.1825632510392, lat: 4.172818068758598 },
      { lng: 114.1854890532274, lat: 4.174204619004539 },
      { lng: 114.1888576597746, lat: 4.173440603798946 },
      { lng: 114.1917350829419, lat: 4.169759330270407 },
      { lng: 114.1927994764042, lat: 4.169450809471078 },
      { lng: 114.1931273167049, lat: 4.17159818521148 },
      { lng: 114.1925468903378, lat: 4.174365168908986 },
      { lng: 114.1333489467108, lat: 4.193018659620925 },
      { lng: 114.130179647197, lat: 4.186791196031941 },
      { lng: 114.1255039343396, lat: 4.179673209006123 },
      { lng: 114.120081711155, lat: 4.173483632715186 },
      { lng: 114.115720680227, lat: 4.169419113807232 },
      { lng: 114.1098360287885, lat: 4.166863080176957 },
      { lng: 114.1060727198639, lat: 4.163777381885949 },      
    ],
  },
  {
    owner: "Log Oak Promotions Sdn Bhd - Lot 67 Bok L.D",
    area: '3,918 ha',
    pv: '7,248 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.1232061066, lat: 3.656230756 },
      { lng: 114.124457444, lat: 3.6592390554 },
      { lng: 114.1338543914, lat: 3.6818293041 },
      { lng: 114.1408091563, lat: 3.6985478161 },
      { lng: 114.140809217, lat: 3.6985479575 },
      { lng: 114.1424304853, lat: 3.6983049973 },
      { lng: 114.1424310284, lat: 3.6983048899 },
      { lng: 114.1424311038, lat: 3.698304879600001 },
      { lng: 114.1449755705, lat: 3.697820526500001 },
      { lng: 114.1468809422, lat: 3.6976965136 },
      { lng: 114.1486658613, lat: 3.697333629 },
      { lng: 114.1499792439, lat: 3.698407335999999 },
      { lng: 114.1516496333, lat: 3.6998390822 },
      { lng: 114.1516499458, lat: 3.6998393443 },
      { lng: 114.1570598308, lat: 3.7043878035 },
      { lng: 114.1622424248, lat: 3.7088981831 },
      { lng: 114.1624667134, lat: 3.7194593235 },
      { lng: 114.1621702942, lat: 3.7240892303 },
      { lng: 114.1526072535, lat: 3.7250222959 }, 
      { lng: 114.1490625445, lat: 3.7193391393 }, 
      { lng: 114.1395136297, lat: 3.718729187 }, 
      { lng: 114.1396403097, lat: 3.7241941548 }, 
      { lng: 114.1373510588, lat: 3.7241705608 }, 
      { lng: 114.1328186667, lat: 3.7178810964 }, 
      { lng: 114.126824751, lat: 3.723711539 }, 
      { lng: 114.1242887299, lat: 3.7209802803 }, 
      { lng: 114.1227670254, lat: 3.7225088652 }, 
      { lng: 114.1168493899, lat: 3.718153494400001 }, 
      { lng: 114.1133393891, lat: 3.7223850523 }, 
      { lng: 114.1119069107, lat: 3.721234743300001 }, 
      { lng: 114.1118890265, lat: 3.7187682779 }, 
      { lng: 114.1046387202, lat: 3.713046423499999 }, 
      { lng: 114.0994301238, lat: 3.7089357826 }, 
      { lng: 114.0938201306, lat: 3.7089538347 }, 
      { lng: 114.0936848919, lat: 3.7088636992 }, 
      { lng: 114.0934438389, lat: 3.7087692611 }, 
      { lng: 114.0932276879, lat: 3.708733571399999 }, 
      { lng: 114.0932164389, lat: 3.708733596500001 }, 
      { lng: 114.0931826116, lat: 3.708711055 }, 
      { lng: 114.0924759644, lat: 3.7087533312 }, 
      { lng: 114.0922913418, lat: 3.7087266076 }, 
      { lng: 114.0922350165, lat: 3.7087041264 }, 
      { lng: 114.0921897306, lat: 3.708577603 }, 
      { lng: 114.0922366509, lat: 3.7084282572 }, 
      { lng: 114.0922836563, lat: 3.7083015332 }, 
      { lng: 114.0922741665, lat: 3.7080844826 }, 
      { lng: 114.0920802442, lat: 3.7079221137 }, 
      { lng: 114.0919316676, lat: 3.7079179215 }, 
      { lng: 114.091828422, lat: 3.7080447811 }, 
      { lng: 114.0917590634, lat: 3.708230343699999 }, 
      { lng: 114.0917232621, lat: 3.7083299126 }, 
      { lng: 114.0915748255, lat: 3.7083754671 }, 
      { lng: 114.0914847779, lat: 3.708375667799999 }, 
      { lng: 114.0914280333, lat: 3.7081587276 }, 
      { lng: 114.091510805, lat: 3.7079278963 }, 
      { lng: 114.0915668256, lat: 3.7078147172 }, 
      { lng: 114.0916589621, lat: 3.7077466865 }, 
      { lng: 114.0917059373, lat: 3.7076199524 }, 
      { lng: 114.0917303498, lat: 3.7074570967 }, 
      { lng: 114.0916396981, lat: 3.7071814383 }, 
      { lng: 114.0915737186, lat: 3.7068559828 }, 
      { lng: 114.0915393473, lat: 3.706580193899999 }, 
      { lng: 114.0913381296, lat: 3.7061781575 }, 
      { lng: 114.0911215998, lat: 3.705970615 }, 
      { lng: 114.0910990119, lat: 3.7059344884 }, 
      { lng: 114.0910877578, lat: 3.7059345135 }, 
      { lng: 114.0910875582, lat: 3.7058440716 }, 
      { lng: 114.0904032813, lat: 3.7058275027 }, 
      { lng: 114.0902885421, lat: 3.705850375199999 }, 
      { lng: 114.0902095943, lat: 3.7057691504 }, 
      { lng: 114.0902114089, lat: 3.7055701581 }, 
      { lng: 114.0902245524, lat: 3.7054118559 }, 
      { lng: 114.0901905158, lat: 3.7052853074 }, 
      { lng: 114.0901110989, lat: 3.704996058699999 }, 
      { lng: 114.0900790467, lat: 3.7047519181 }, 
      { lng: 114.0900789768, lat: 3.7047202697 }, 
      { lng: 114.0899885655, lat: 3.7045440997 }, 
      { lng: 114.0897835499, lat: 3.704454108899999 }, 
      { lng: 114.0896820242, lat: 3.7043503174 }, 
      { lng: 114.0895934877, lat: 3.7040023052 }, 
      { lng: 114.0895029866, lat: 3.7037944767 }, 
      { lng: 114.0892074853, lat: 3.7034921389 }, 
      { lng: 114.0888428646, lat: 3.7035020025 }, 
      { lng: 114.0887978486, lat: 3.703502102699999 }, 
      { lng: 114.0887168218, lat: 3.7035022831 }, 
      { lng: 114.0883614507, lat: 3.703616128300001 }, 
      { lng: 114.0883033308, lat: 3.7037971474 }, 
      { lng: 114.0883034605, lat: 3.7038559409 }, 
      { lng: 114.0883018699, lat: 3.7041544118 }, 
      { lng: 114.0882570582, lat: 3.7042494823 }, 
      { lng: 114.0880614968, lat: 3.7043629717 }, 
      { lng: 114.0879467577, lat: 3.7043858338 }, 
      { lng: 114.08786787, lat: 3.7043362673 }, 
      { lng: 114.0878674911, lat: 3.7041644252 }, 
      { lng: 114.0879032527, lat: 3.7040512914 }, 
      { lng: 114.0878466586, lat: 3.7039021761 }, 
      { lng: 114.0878485785, lat: 3.7037484173 }, 
      { lng: 114.0878484788, lat: 3.7037031939 }, 
      { lng: 114.0878144076, lat: 3.7035676036 }, 
      { lng: 114.0876901749, lat: 3.703368891699999 }, 
      { lng: 114.0876337305, lat: 3.7032876167 }, 
      { lng: 114.0875452994, lat: 3.7029893461 }, 
      { lng: 114.0875580096, lat: 3.7026320515 }, 
      { lng: 114.0875803132, lat: 3.7025415646 }, 
      { lng: 114.0875821233, lat: 3.7023425722 }, 
      { lng: 114.0875482168, lat: 3.7022748121 }, 
      { lng: 114.0875142656, lat: 3.7021844402 }, 
      { lng: 114.0874465771, lat: 3.7021122369 }, 
      { lng: 114.0872077156, lat: 3.701986144 }, 
      { lng: 114.0870141791, lat: 3.7019956263 }, 
      { lng: 114.086888286, lat: 3.7020637368 }, 
      { lng: 114.0867733827, lat: 3.7020187737 }, 
      { lng: 114.0866942511, lat: 3.7018561434 }, 
      { lng: 114.0866961909, lat: 3.7017159445 }, 
      { lng: 114.0867317283, lat: 3.7014987988 }, 
      { lng: 114.0867674949, lat: 3.701385665000001 }, 
      { lng: 114.0867898185, lat: 3.7013042147 }, 
      { lng: 114.0869627818, lat: 3.701145547 }, 
      { lng: 114.087066102, lat: 3.7010503464 }, 
      { lng: 114.0870998938, lat: 3.7010638414 }, 
      { lng: 114.0872031842, lat: 3.7009505524 }, 
      { lng: 114.0872481004, lat: 3.7009052287 }, 
      { lng: 114.0872613042, lat: 3.7007650048 }, 
      { lng: 114.0871255488, lat: 3.7004442225 }, 
      { lng: 114.0868660948, lat: 3.7001644258 }, 
      { lng: 114.0867417829, lat: 3.6999340553 }, 
      { lng: 114.0867075527, lat: 3.6997170697 }, 
      { lng: 114.086675656, lat: 3.6995407691 }, 
      { lng: 114.0866056741, lat: 3.699450477400001 }, 
      { lng: 114.0865605687, lat: 3.699405348900001 }, 
      { lng: 114.0862314571, lat: 3.6991844957 }, 
      { lng: 114.0860379808, lat: 3.6992256212 }, 
      { lng: 114.0858896201, lat: 3.6993073466 }, 
      { lng: 114.085741075, lat: 3.6993076769 }, 
      { lng: 114.085536001, lat: 3.699199612 }, 
      { lng: 114.0853758484, lat: 3.6990371566 }, 
      { lng: 114.085172899, lat: 3.6988657697 }, 
      { lng: 114.0851051662, lat: 3.6987709494 }, 
      { lng: 114.0849450137, lat: 3.6986130223 }, 
      { lng: 114.0848095881, lat: 3.6984369518 }, 
      { lng: 114.0847191931, lat: 3.6982743513 }, 
      { lng: 114.0843334793, lat: 3.6978953352 }, 
      { lng: 114.0843222254, lat: 3.6978953602 }, 
      { lng: 114.0842769857, lat: 3.6977914533 }, 
      { lng: 114.084120684, lat: 3.6973395684 }, 
      { lng: 114.0838925954, lat: 3.6969918554 }, 
      { lng: 114.0838381963, lat: 3.6968201282 }, 
      { lng: 114.0838041859, lat: 3.6967026261 }, 
      { lng: 114.0836330685, lat: 3.6966803993 }, 
      { lng: 114.0835429626, lat: 3.6966444124 }, 
      { lng: 114.0834732054, lat: 3.6966445673 }, 
      { lng: 114.0832664806, lat: 3.6968033094 }, 
      { lng: 114.0832328929, lat: 3.6968847847 }, 
      { lng: 114.0832195643, lat: 3.696966215 }, 
      { lng: 114.0830359342, lat: 3.6973917246 }, 
      { lng: 114.0829888687, lat: 3.6974822665 }, 
      { lng: 114.082955316, lat: 3.6975727935 }, 
      { lng: 114.0828048207, lat: 3.6977133221 }, 
      { lng: 114.0826113447, lat: 3.6977544469 }, 
      { lng: 114.082372674, lat: 3.6977097479 }, 
      { lng: 114.0821902876, lat: 3.6976830276 }, 
      { lng: 114.0820304441, lat: 3.6976607655 }, 
      { lng: 114.0819268852, lat: 3.6976474353 }, 
      { lng: 114.0817690119, lat: 3.6975075911 }, 
      { lng: 114.0817911023, lat: 3.6973130872 }, 
      { lng: 114.0818832033, lat: 3.6972360005 }, 
      { lng: 114.0819866877, lat: 3.697213164 }, 
      { lng: 114.0820541367, lat: 3.6971768272 }, 
      { lng: 114.0821012171, lat: 3.6970953221 }, 
      { lng: 114.0821031329, lat: 3.696937034799999 }, 
      { lng: 114.0821029042, lat: 3.696833027899999 }, 
      { lng: 114.0820125545, lat: 3.6966930339 }, 
      { lng: 114.0819333694, lat: 3.6965078015 }, 
      { lng: 114.0817170528, lat: 3.6963906988 }, 
      { lng: 114.0814780643, lat: 3.6962058159 }, 
      { lng: 114.0814667905, lat: 3.6961967942 }, 
      { lng: 114.0813086093, lat: 3.6959167662 }, 
      { lng: 114.0811958764, lat: 3.6958265689 }, 
      { lng: 114.0810830095, lat: 3.6956730647 }, 
      { lng: 114.0809700528, lat: 3.695487897 }, 
      { lng: 114.0808458128, lat: 3.695280147500001 }, 
      { lng: 114.0807082937, lat: 3.6951764451 }, 
      { lng: 114.0805730531, lat: 3.695086292500001 }, 
      { lng: 114.0803904736, lat: 3.6949691198 }, 
      { lng: 114.0803566622, lat: 3.6949465779 }, 
      { lng: 114.08019671, lat: 3.6948745838 }, 
      { lng: 114.0801065396, lat: 3.6948159899 }, 
      { lng: 114.0800611119, lat: 3.6946216306 }, 
      { lng: 114.0801644071, lat: 3.6945173941 }, 
      { lng: 114.0802341742, lat: 3.694517239400001 }, 
      { lng: 114.0803354742, lat: 3.6945215381 }, 
      { lng: 114.0805177902, lat: 3.694521133799999 }, 
      { lng: 114.0807248974, lat: 3.6945432812 }, 
      { lng: 114.0810086128, lat: 3.6945923939 }, 
      { lng: 114.081191038, lat: 3.6946507831 }, 
      { lng: 114.081373533, lat: 3.6947317789 }, 
      { lng: 114.081465818, lat: 3.6947315741 }, 
      { lng: 114.0815895114, lat: 3.6946860759 }, 
      { lng: 114.0816364375, lat: 3.6945367355 }, 
      { lng: 114.081615756, lat: 3.6943423264 }, 
      { lng: 114.0813766685, lat: 3.69411222 }, 
      { lng: 114.0813090808, lat: 3.694076187999999 }, 
      { lng: 114.0812414628, lat: 3.694040161 }, 
      { lng: 114.0811829398, lat: 3.6940312492 }, 
      { lng: 114.0810703313, lat: 3.6940043637 }, 
      { lng: 114.0808767417, lat: 3.693991222999999 }, 
      { lng: 114.0807035204, lat: 3.6940277842 }, 
      { lng: 114.080554986, lat: 3.6940371655 }, 
      { lng: 114.0804536165, lat: 3.6940012134 }, 
      { lng: 114.0804535967, lat: 3.693992161600001 }, 
      { lng: 114.0805117124, lat: 3.6938066144 }, 
      { lng: 114.0806038929, lat: 3.6937611964 }, 
      { lng: 114.0806825012, lat: 3.6936796213 }, 
      { lng: 114.0807747758, lat: 3.693683935000001 }, 
      { lng: 114.0808668966, lat: 3.6936113717 }, 
      { lng: 114.0809362412, lat: 3.6934167578 }, 
      { lng: 114.0810056009, lat: 3.693222148999999 }, 
      { lng: 114.0810522339, lat: 3.6929371381 }, 
      { lng: 114.0810427366, lat: 3.692715574 }, 
      { lng: 114.0810332147, lat: 3.6924759113 }, 
      { lng: 114.0810241252, lat: 3.6924352261 }, 
      { lng: 114.0809992941, lat: 3.6924036226 }, 
      { lng: 114.0809699705, lat: 3.692372034 }, 
      { lng: 114.0809316664, lat: 3.6923585489 }, 
      { lng: 114.0808753922, lat: 3.692354155399999 }, 
      { lng: 114.0807943864, lat: 3.6923588534 }, 
      { lng: 114.0805649506, lat: 3.692427203 }, 
      { lng: 114.0803808236, lat: 3.692622071400001 }, 
      { lng: 114.0802909316, lat: 3.6926901013 }, 
      { lng: 114.0802213634, lat: 3.6927807081 }, 
      { lng: 114.080106725, lat: 3.6928487928 }, 
      { lng: 114.0799808824, lat: 3.6929395143 }, 
      { lng: 114.0797965166, lat: 3.693030375599999 }, 
      { lng: 114.0796592264, lat: 3.69303068 }, 
      { lng: 114.0795220751, lat: 3.6930988095 }, 
      { lng: 114.0793870536, lat: 3.6931081607 }, 
      { lng: 114.0792271613, lat: 3.6930632914 }, 
      { lng: 114.0791707528, lat: 3.6930046226 }, 
      { lng: 114.0791591661, lat: 3.692855412 }, 
      { lng: 114.0791609681, lat: 3.6926473829 }, 
      { lng: 114.0791607397, lat: 3.6925433759 }, 
      { lng: 114.0791153468, lat: 3.6923716284 }, 
      { lng: 114.0789236786, lat: 3.6922092518 }, 
      { lng: 114.0787076016, lat: 3.692205207299999 }, 
      { lng: 114.0785861124, lat: 3.6922326067 }, 
      { lng: 114.0783633833, lat: 3.6922738057 }, 
      { lng: 114.0782036301, lat: 3.6922967664 }, 
      { lng: 114.0780663498, lat: 3.6923061173 }, 
      { lng: 114.0779291691, lat: 3.692351645 }, 
      { lng: 114.0776548219, lat: 3.692465312 }, 
      { lng: 114.0774727148, lat: 3.6925561577 }, 
      { lng: 114.0771869797, lat: 3.692611061 }, 
      { lng: 114.076946151, lat: 3.692611594300001 }, 
      { lng: 114.0767301632, lat: 3.6926482495 }, 
      { lng: 114.0764667128, lat: 3.6925945673 }, 
      { lng: 114.0763201894, lat: 3.6924908741 }, 
      { lng: 114.0761960894, lat: 3.6923509542 }, 
      { lng: 114.0760810244, lat: 3.6922245845 }, 
      { lng: 114.0759231629, lat: 3.692084749500001 }, 
      { lng: 114.0757629485, lat: 3.6918996858 }, 
      { lng: 114.0756274313, lat: 3.6916829189 }, 
      { lng: 114.0755034803, lat: 3.6916108342 }, 
      { lng: 114.0753774887, lat: 3.6916337299 }, 
      { lng: 114.0752855711, lat: 3.6917967346 }, 
      { lng: 114.0752047634, lat: 3.6918964026 }, 
      { lng: 114.0751239459, lat: 3.6919915471 }, 
      { lng: 114.0749757587, lat: 3.6921591997 }, 
      { lng: 114.0748499701, lat: 3.6922770606 }, 
      { lng: 114.0748028151, lat: 3.6923223836 }, 
      { lng: 114.0745394638, lat: 3.6923184427 }, 
      { lng: 114.0743458798, lat: 3.6923053057 }, 
      { lng: 114.0742333462, lat: 3.692305554599999 }, 
      { lng: 114.0739248061, lat: 3.6922248362 }, 
      { lng: 114.0739490573, lat: 3.6919941457 }, 
      { lng: 114.074063696, lat: 3.6919260617 }, 
      { lng: 114.0742570273, lat: 3.6918216166 }, 
      { lng: 114.0743267203, lat: 3.6917762387 }, 
      { lng: 114.0744883603, lat: 3.6915949914 }, 
      { lng: 114.0744879837, lat: 3.691423144099999 }, 
      { lng: 114.0745930227, lat: 3.6910792206 }, 
      { lng: 114.0745947959, lat: 3.6908576215 }, 
      { lng: 114.074595291, lat: 3.6907644488 }, 
      { lng: 114.0747801324, lat: 3.6906014003 }, 
      { lng: 114.0804178341, lat: 3.6856283655 }, 
      { lng: 114.088042108, lat: 3.6789028249 }, 
      { lng: 114.1197020218, lat: 3.6486215273 }, 
      { lng: 114.1232061066, lat: 3.656230756 },             
    ],
  },
  {
    owner: "Mukah Coal Energy - balance area",
    area: '1,230 ha',
    pv: '2,276 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 112.2665356663205, lat: 2.701704211479448 }, 
      { lng: 112.2696779927933, lat: 2.697513757070808 }, 
      { lng: 112.2686770363446, lat: 2.696945636796647 }, 
      { lng: 112.2684335509229, lat: 2.695434459436069 }, 
      { lng: 112.266811127844, lat: 2.69457241234358 }, 
      { lng: 112.2662367736621, lat: 2.693425965773634 }, 
      { lng: 112.2668031060851, lat: 2.691365292027805 }, 
      { lng: 112.2676050818636, lat: 2.689196692222514 }, 
      { lng: 112.2672465309115, lat: 2.688064257348054 }, 
      { lng: 112.266812161308, lat: 2.687049116083317 }, 
      { lng: 112.2671887703313, lat: 2.685529510846268 }, 
      { lng: 112.2673175231793, lat: 2.684265241815392 }, 
      { lng: 112.2685520861526, lat: 2.681986206052058 }, 
      { lng: 112.271177779657, lat: 2.680134672809528 }, 
      { lng: 112.2733000661942, lat: 2.680122902525754 }, 
      { lng: 112.2751080414044, lat: 2.680424301354121 }, 
      { lng: 112.2773790579042, lat: 2.680260867498903 }, 
      { lng: 112.277618065888, lat: 2.679567472339213 }, 
      { lng: 112.2877063659515, lat: 2.67934414018667 }, 
      { lng: 112.2874894510161, lat: 2.691102462656904 }, 
      { lng: 112.3233340497936, lat: 2.691025445671739 }, 
      { lng: 112.3256319102778, lat: 2.691606479533993 }, 
      { lng: 112.3261328688495, lat: 2.694050916599299 }, 
      { lng: 112.3243731037496, lat: 2.696515441613726 }, 
      { lng: 112.3209346601609, lat: 2.698677087911038 }, 
      { lng: 112.3139171204736, lat: 2.697685437357522 }, 
      { lng: 112.3123416393808, lat: 2.702051397659907 }, 
      { lng: 112.3175368643371, lat: 2.706940891637318 }, 
      { lng: 112.3238198102702, lat: 2.708207343681989 }, 
      { lng: 112.3314597892, lat: 2.699818846784888 }, 
      { lng: 112.3301298050667, lat: 2.706401168189515 }, 
      { lng: 112.327254006684, lat: 2.709953586700606 }, 
      { lng: 112.3116093107786, lat: 2.709456077523794 }, 
      { lng: 112.3040626333428, lat: 2.705832633199809 }, 
      { lng: 112.2980791957381, lat: 2.708712262242298 }, 
      { lng: 112.2903083807871, lat: 2.707923778257868 }, 
      { lng: 112.2889139644121, lat: 2.701721956753605 }, 
      { lng: 112.2878507092058, lat: 2.699454442458024 }, 
      { lng: 112.2862041849615, lat: 2.698044889797192 }, 
      { lng: 112.2844824150391, lat: 2.697814252186168 }, 
      { lng: 112.2830547254112, lat: 2.696816312783371 }, 
      { lng: 112.2792759978865, lat: 2.698067609365305 }, 
      { lng: 112.2754259195477, lat: 2.706595732385194 }, 
      { lng: 112.2741168446776, lat: 2.706416038380033 }, 
      { lng: 112.271844469528, lat: 2.705412137014176 }, 
      { lng: 112.2703484621353, lat: 2.704831778218753 }, 
      { lng: 112.2677594174264, lat: 2.703138842420611 }, 
      { lng: 112.2665356663205, lat: 2.701704211479448 }, 
    ],
  },
  {
    owner: "Mutual Ethics - Lot 2176",
    area: '125 ha',
    pv: '230.5 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.0330980157357, lat: 4.407665011862472 }, 
      { lng: 114.0326629227059, lat: 4.40298201544047 }, 
      { lng: 114.0317018126272, lat: 4.402512002813729 }, 
      { lng: 114.0301124526533, lat: 4.401151835537814 }, 
      { lng: 114.0307071820456, lat: 4.399943442274284 }, 
      { lng: 114.0320370890311, lat: 4.399473231804953 }, 
      { lng: 114.0326739904884, lat: 4.399476153458434 }, 
      { lng: 114.0335974671712, lat: 4.399030153128122 }, 
      { lng: 114.0337648386698, lat: 4.398612755608581 }, 
      { lng: 114.0337568151864, lat: 4.398015485884746 }, 
      { lng: 114.0338006136136, lat: 4.397396686424644 }, 
      { lng: 114.0335081627396, lat: 4.396858884577419 }, 
      { lng: 114.0332888069614, lat: 4.396476745300807 }, 
      { lng: 114.0333041057561, lat: 4.396149994857741 }, 
      { lng: 114.0337326451608, lat: 4.396080219160931 }, 
      { lng: 114.0343141777817, lat: 4.396375143847209 }, 
      { lng: 114.0348047086641, lat: 4.396172067177862 }, 
      { lng: 114.0353435699908, lat: 4.39604537943336 }, 
      { lng: 114.0353742798565, lat: 4.395792535625943 }, 
      { lng: 114.0351250730272, lat: 4.395540396375443 }, 
      { lng: 114.0351327340874, lat: 4.395188613346112 }, 
      { lng: 114.0347333433714, lat: 4.394913190259032 }, 
      { lng: 114.0347804098515, lat: 4.394624242495938 }, 
      { lng: 114.0355089917858, lat: 4.394166397908288 }, 
      { lng: 114.0397919537025, lat: 4.397088820849791 }, 
      { lng: 114.0340543690531, lat: 4.405538170196022 }, 
      { lng: 114.033422862403, lat: 4.406486670259024 }, 
      { lng: 114.0330980157357, lat: 4.407665011862472 }, 
    ],
  },
  {
    owner: "Mutual Ethics - Lot 2177",
    area: '125 ha',
    pv: '230.5 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.0346823827533, lat: 4.408569239965742 }, 
      { lng: 114.0349664756235, lat: 4.404543878564764 }, 
      { lng: 114.0399954731991, lat: 4.397175856838784 }, 
      { lng: 114.0424284087221, lat: 4.398873101466709 }, 
      { lng: 114.0413903997478, lat: 4.40122983096549 },
      { lng: 114.0405893612288, lat: 4.403969500537922 }, 
      { lng: 114.0389032030461, lat: 4.405546846710289 }, 
      { lng: 114.0395717044193, lat: 4.406218762783169 }, 
      { lng: 114.0377400101683, lat: 4.407843062592915 }, 
      { lng: 114.0360680854002, lat: 4.408773586510406 }, 
      { lng: 114.0346823827533, lat: 4.408569239965742 }, 
    ],
  },
  {
    owner: "Mutual Ethics - Lot 2178",
    area: '125 ha',
    pv: '230.5 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.0422254897419, lat: 4.401483015779343 }, 
      { lng: 114.0432078231898, lat: 4.399408354265003 }, 
      { lng: 114.0455347294765, lat: 4.400991342402726 }, 
      { lng: 114.0424791339232, lat: 4.403925298193006 }, 
      { lng: 114.0416843589187, lat: 4.403236368593443 }, 
      { lng: 114.0422254897419, lat: 4.401483015779343 }, 
    ],
  },
  {
    owner: "Spirit Ethic - TM4 Sungai Nakan & Tuyo",
    area: '6,375 ha',
    pv: '11,794 MWp',
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [
      { lng: 114.3836543003148, lat: 3.450528095242609 }, 
      { lng: 114.3853072776189, lat: 3.436436255222942 }, 
      { lng: 114.3718855964566, lat: 3.423288192943494 }, 
      { lng: 114.3756973209459, lat: 3.38310629821257 }, 
      { lng: 114.4077672303994, lat: 3.357874919011358 }, 
      { lng: 114.4128668599234, lat: 3.357387701345528 }, 
      { lng: 114.4164802622356, lat: 3.361822886335752 }, 
      { lng: 114.4273575968998, lat: 3.366143534003836 }, 
      { lng: 114.4259097701903, lat: 3.370609252483233 }, 
      { lng: 114.4348150866638, lat: 3.371281466197414 }, 
      { lng: 114.445367627266, lat: 3.371041172659258 }, 
      { lng: 114.4487096427656, lat: 3.378115421017351 }, 
      { lng: 114.4509311773784, lat: 3.383124289511116 }, 
      { lng: 114.4511150865357, lat: 3.385820762882263 }, 
      { lng: 114.4509014998647, lat: 3.390026670446342 }, 
      { lng: 114.4535489668103, lat: 3.397847325493419 }, 
      { lng: 114.4576179220683, lat: 3.407163541479898 }, 
      { lng: 114.4477103684344, lat: 3.410066967258508 }, 
      { lng: 114.4391607606446, lat: 3.412977706038712 }, 
      { lng: 114.4355658732872, lat: 3.413187247686655 }, 
      { lng: 114.4308451732383, lat: 3.415877715248449 }, 
      { lng: 114.4282905975455, lat: 3.42043667258262 }, 
      { lng: 114.4238572113935, lat: 3.424009365965162 }, 
      { lng: 114.4206465554772, lat: 3.429008074376249 }, 
      { lng: 114.4211016400278, lat: 3.432632611422485 }, 
      { lng: 114.4236105548658, lat: 3.436939761469442 }, 
      { lng: 114.4258838902917, lat: 3.442608189881971 }, 
      { lng: 114.4259348047045, lat: 3.4517216184514 }, 
      { lng: 114.3836543003148, lat: 3.450528095242609 },
    ],
  },



  /*
  {
    owner: "template",
    cert_no: "tbo",
    isVerified: true,
    isValid: true,
    // isVerified: true,
    // isValid: true,
    NEcoord: [],
    coord: [

    ],
  },
  */
];

export default dataCert;
